import { useQuery, UseQueryOptions } from 'react-query';

import { TeamMember, Guid, DataRoomUser } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useLenderDataRoomUserQuery(
	guid: Guid | undefined,
	userGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<DataRoomUser, unknown, DataRoomUser, any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.LenderByUser(guid, userGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomUser>(
				api.get(CerebroApiEndpoints.DataRoomUsers.LenderByUser(guid, userGuid))
			),
		options
	);
}
